import { InjectionToken } from '@angular/core';

export const PROPOSAL_PARTNER_DATA = new InjectionToken<any>(
  'Proposal partner data'
);
